<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>危大监测</el-breadcrumb-item>
            <el-breadcrumb-item>深基坑监测</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main
        style="
          height: 100%;
          padding: 0px !important;
          position: relative;
          width: 100%;
        "
      >
        <el-card style="height: 100% !important" class="aside">
          <div class="add">
            <el-button type="primary" @click="addDeep">添加</el-button>
          </div>
          <div style="height: calc(100% - 150px);overflow: auto;">
            <!-- <div class="secend_content" v-for="(item,index) in listData"  :key="index">
              <div class="entRisk_content" >
                <div class="th_one">
                  <div>设备编号：{{item.tsDtuId}}</div>
                  <div>设备名称：{{item.name}}</div>
                </div>
                <div>
                  联网状态:
                  <span style="color: #36c635" v-if="item.online=='在线'">{{item.online}}</span>
                  <span style="color: #f00" v-else-if="item.online=='离线'">{{item.online}}</span>
                  <span  v-else>{{item.online}}</span>
                </div>
                <div>时间：{{item.createDate}}</div>
                <div style="position: relative;padding:20px 0 0;">
                   <img class="blue" style="width:120px;height:120px;" src="../../assets/image/white.png" alt />
                   <img  class="round" :class="item.online=='在线'?'round_normal':''" style="width:120px;height:120px;top: 20px;" src="../../assets/image/round.png" alt />
                   <div style="position: absolute; top: 50px; left: 18px; color: #6b6b6b; " >
                    <div v-if="item.statueName=='正常'">监测正常</div>
                    <div v-else-if="item.statueName=='预警'" style="color:#E6A23C;">监测预警</div>
                    <div>24小时</div>
                  </div>
                </div>
                <div>
                  <el-button type="primary" @click.stop="handSet(item.tsDtuSensorId,item.id,item.index)">预警设置</el-button>
                  <el-button type="danger" @click.stop="reset(item.id)" plain>重置初始值</el-button>
                  <el-button size="mini" @click="bindDtu(item)" >绑定传感器主机</el-button>
                  <el-button type="success" @click="toInfo(item)">查看</el-button>
                  <el-button type="warning" @click.stop="handleEditEq(item)">编辑</el-button>
                  <el-button type="info"  @click.stop="macDelete(item.tsDtuSensorId)">解绑</el-button>
                  <el-button type="danger"  @click.stop="handeldelete(item.id)">删除</el-button> 
                </div>
              </div> -->
              <!-- <div style="padding:1vh 1vw;text-align: right;"><el-button type="primary" @click="add">观测点添加</el-button></div> -->
              <el-table :data="listData" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                  <el-table-column label="序号" type="index" width="100"></el-table-column>
                  <el-table-column label="名称">
                      <template slot-scope="scope">
                          <span>{{ scope.row.name }}</span>
                      </template>
                  </el-table-column>
                  <el-table-column label="传感器主机">
                      <template slot-scope="scope">
                          <!-- <span>{{ scope.row.tsSersorTypeName }}</span> -->
                          <p v-for="(item,index) in scope.row.tsDtusList" :key="index" style="padding:0.5vh;">
                            <span>{{item.name}}</span>
                            <i class="el-icon-close" @click="delDtu(item.tsDtuSensorId)" style="color:red;font-size:1vw;margin-left:1vw;cursor: pointer;"></i>
                          </p>
                      </template>
                  </el-table-column>
                  <el-table-column label="设备号">
                      <template slot-scope="scope">
                          <!-- <span>{{ scope.row.tsSersorImei }}</span> -->
                          <p v-for="(item,index) in scope.row.tsDtusList" :key="index" style="padding:0.5vh;">{{item.dtuImei}}</p>
                      </template>
                  </el-table-column>
                  <!-- <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.online=='在线'" style="color:#67C23A;">{{scope.row.online}}</span>
                        <span v-else-if="scope.row.online=='离线'" style="color:#F56C6C;">{{scope.row.online}}</span>
                        <span v-else-if="scope.row.online=='失效'" style="color:#909399;">{{scope.row.online}}</span>
                        <span v-else-if="scope.row.online=='未连接'" style="color:#E6A23C;">{{scope.row.online}}</span>
                        <span v-else style="color:#909399;">{{scope.row.online}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数据监测">
                      <template slot-scope="scope">
                          <span v-if="scope.row.status==0" style="color:#67C23A;">{{ scope.row.nowValue }}</span>
                          <span v-else-if="scope.row.status==-1" style="color:#F56C6C;">{{ scope.row.nowValue }}</span>
                      </template>
                  </el-table-column> -->
                  <el-table-column label="操作" width="400">
                      <template slot-scope="scope">
                        <el-button size="mini" @click="bindDtu(scope.row)" type="primary">绑定传感器</el-button>
                        <el-button size="mini" @click="initDtu(scope.row)" type="danger" plain>重置初始化</el-button>
                        <el-button size="mini" @click="handleEditEq(scope.row)" type="warning">修改</el-button>
                        <el-button size="mini" @click="toInfo(scope.row)" type="primary">查看</el-button>
                      </template>
                  </el-table-column>
               </el-table>
            <!-- </div> -->
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <!-- 添加弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
        :rules="addRules"
      >
        <el-form-item label="设备名称：">
          <el-input
            v-model="addForm.name"
            autocomplete="off"
            style="width: 217px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 绑定dtu -->
    <el-dialog
      title="绑定传感器主机"
      :visible.sync="bindVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="bindForm"
        ref="addForm"
        label-width="150px"
        :label-position="labelPosition"
      >
        <el-form-item label="设备名称：">
          <span>{{bindForm.name}}</span>
          <!-- <el-input
            v-model="addForm.name"
            autocomplete="off"
            style="width: 217px"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="设备号:">
          <el-select v-model="bindForm.dtuIds" multiple clearable placeholder="请选择">
            <el-option
              v-for="item in TsDtuList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindAddRow()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 预警弹框 -->
    <!-- <el-dialog
      :title="dialogSetTitle"
      :visible.sync="setVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="30%"
    >
      <el-form
        :model="setForm"
        ref="setForm"
        label-width="150px"
        :label-position="labelPosition"
      > 
        <div v-for="(item,index) in type" :key="index">
           <el-form-item :label="item.name">
              <el-input-number v-model="item.num" @change="handleChange" :step="1"  label="描述文字"></el-input-number>
               <span v-if="item.tsSersorType==1">   mm</span>
               <span v-if="item.tsSersorType==2">   mm</span>
               <span v-if="item.tsSersorType==3">   mm</span>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitSetRow('setForm')">确 定</el-button>
        <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
      </div>
    </el-dialog> -->

    <!--添加观测点 弹出框 -->
    <!-- <el-dialog
      title="添加观测点"
      :visible.sync="temperVis"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
      style="height: 100%"
    >
      <el-form
        :model="creatForm"
        ref="creatForm"
        label-width="200px"
        :label-position="labelPosition"
      >
        <el-form-item label="名称">
          <el-input
            style="width: 217px"
            v-model="creatForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="传感器设备号">
          <el-input
            style="width: 217px"
            v-model="creatForm.tsSersorImei"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="监测类型:">
          <el-select
            v-model="creatForm.tsSersorType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="temperVis = false">取 消</el-button>
        <el-button type="primary" @click="sumbitEquip('creatForm')">确 定</el-button >
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
// import { delete } from 'vuedraggable'
export default {
  data() {
    return {
      secondTitle: '',
      groupId: '',
      // prevPage: '', //上一个页面
      // istowe: true,
      listData: [],
      // personList: [{
      //   id:'0102',
      //   tsDtuId:'18877787',
      //   name:'',
      //   online:'离线',
      //   createDate:'2020.05.10 15:33:38',
      //   statueName:'正常',
      //   tsDtuSensorList:[
      //     {index:'1',name:'移位监测',tsSersorTypeName:'上',tsSersorImei:'12G9487469385479',online:'离线',status:0,nowValue:'0.5'},
      //     {index:'2',name:'下沉监测',tsSersorTypeName:'中',tsSersorImei:'28F4234539385846',online:'离线',status:0,nowValue:'0.0'},
      //     {index:'3',name:'水位监测',tsSersorTypeName:'下',tsSersorImei:'50S2212345688546',online:'离线',status:0,nowValue:'0.3'}
      //   ],
      // }],
      // curTime: util.myTime.formatTime(new Date(), 'YYYY年MM月dd日 HH:mm:ss'),
      // nodata: false,
      // istower: true,
      // istowerPro: false,
      // port: '',
      // y: '1',
      TsDtuList: [], //DTU设备列表
      addFormVisible: false,
      dialogTitle: '',
      addForm: {
        name: '',
        createBy: '',
        projectId: '',
      },
      addRules:{
        name:[{ required: true, message: '请输入名称', trigger: 'blur' },]
      },
      // tsDtuId:'',
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      //绑定dtu
      bindForm:{
        id:'',
        name:'',
        dtuIds:[],
        createBy:''
      },
      bindVisible:false,
      labelPosition: 'right', // 添加设备弹出框position属性
      // dialogSetTitle:'设置预警参数',
      // setVisible:false,
      // setForm:{},
      // id:'',
      // type:[{name:'位移',tsSersorType:'1',num:'1'},{name:'下沉',tsSersorType:'2',num:'0.6'},{name:'水位',tsSersorType:'3',num:'0.6'},],
      // //添加观测点
      // creatForm: {
      //   name: '',
      //   tsDtuId: '',
      //   useId: '',
      //   tsSersorImei: '',
      //   createBy: '',
      //   tsSersorType: '',
      //   usedFor: '',
      // },
      // temperVis: false, //添加温度测点弹出框
      // types:[],
    }
  },
  mounted() {
    // this.port = util.session.get('roleId')
    // if (this.port == '4') {
    //   this.groupId = util.session.get('groupId')
    //   this.istower = false
    //   this.getData()
    // }
    // if (this.$route.name == 'deepPro' && this.port == '4') {
    //   this.istowerPro = true
    // } else {
    //   this.istowerPro = false
    // }
    // if (util.session.get('proId')) {
    //   this.groupId = util.session.get('proId')
    // }
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp.getTsDeepPitPage({
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        projectId:this.groupId
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.pageInfo.list||[]
          that.listData = list
          for(var i=0;i<list.length;i++){
            list[i].tsSersorTypeName = ''
            list[i].tsSersorImei = ''
            // for(var j=0;j<list[i].tsDtusList.length;j++){
            //   if(list[i].tsSersorTypeName==''){
            //     list[i].tsSersorTypeName = list[i].tsDtusList[j].name
            //     list[i].tsSersorImei = list[i].tsDtusList[j].dtuImei
            //   }else{
            //     list[i].tsSersorTypeName += ','+list[i].tsDtusList[j].name
            //     list[i].tsSersorImei += ','+ list[i].tsDtusList[j].dtuImei
            //   }
            // }
          }
        }
      })
    },
    
    //添加
    addDeep(){
      this.addFormVisible = true
      this.addForm.name = ''
      this.addForm.id = ''
    },
    sumbitAddRow(formName){
      var that = this
      this.addForm.projectId = this.groupId
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.addForm.id==''){
              that.addForm.createBy = util.session.get('user').id
              myHttp.addTsDeepPit(that.addForm).then(function(resp){
                if(resp.data.code=='200'){
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getData()
                }else{
                  that.$message.error(resp.data.msg)
                }
              })
            }else{
              that.addForm.updateBy = util.session.get('user').id
              myHttp.updateTsDeepPit(that.addForm).then(function(resp){
                if(resp.data.code=='200'){
                  that.$message.success('编辑成功')
                  that.addFormVisible = false
                  that.getData()
                }else{
                  that.$message.error(resp.data.msg)
                }
              })
            }
          } else {
            return false;
          }
      });
    },

    //绑定Dut设备
    bindDtu(row){
      this.bindVisible = true
      this.bindForm.name = row.name
      this.bindForm.id = row.id
      this.bindForm.dtuIds = []
      for(var i=0;i<row.tsDtusList.length;i++){
        this.bindForm.dtuIds.push(row.tsDtusList[i].id)
      }
      this.getMachine()
    },
    bindAddRow(){
      var that = this
      this.bindForm.createBy = util.session.get('user').id
      this.bindForm.dtuIds = this.bindForm.dtuIds.join(',')
      myHttp.bindingDeepDtu(this.bindForm).then(function(resp){
        if(resp.data.code=='200'){
          that.$message.success('绑定成功')
          that.bindVisible = false
          that.getData()
        }else{
          that.$message.error(resp.data.msg)
        }
      })
    },

    goBack() {
      this.$router.go(-1)
    },

    // 设备列表
    getMachine() {
      var that = this
      myHttp
        .selectTsDtuByList({
          groupId: this.groupId,
          userType: util.session.get('roleId'),
          useType:'3'
        }).then(
          function (resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.TsDtu || []
              that.TsDtuList = list
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
    
    //字典表（检测类型）
    getDict() {
      var that = this
      myHttp.getDictByType({
          type: 'monitor_type',
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.types = resp.data.data.dictList
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    //编辑
    handleEditEq(row) {
      this.addFormVisible = true
      this.addForm.name = row.name
      this.addForm.id = row.id
    },
    //查看
    toInfo(row){
      this.$router.push({path:'/deepProRecord/'+row.id})
    },
    handeldelete(id) {
       var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteTsDeepPit({
            id: id,
            updateBy:util.session.get('user').id
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
    //初始化
    initDtu(row){
      var that = this
      myHttp.resetValue({
          useId:row.id
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.$message.success(resp.data.msg)
        } else {
          that.$message.error(resp.data.msg)
        }
      },function () {})
      
    },
    //解绑主机
    delDtu(id){
      var that = this
      this.$confirm('此操作将解除设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp.unbundlingTsDtuSensorDTU({
            id: id,
            updateBy:util.session.get('user').id
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('解除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.secend_content {
  /* margin-top: 30px; */
  margin-bottom: 30px;
  background: #f5f5f5;
  /* padding: 0 50px; */
  overflow: hidden;
}
.entRisk_content {
  width: 95%;
  /* height: ; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #f5f5f5;
  cursor: pointer;
}
.entRisk_bot {
  width: 95%;
  background: #011c56;
}
.left_head {
  /* width: 20%; */
  display: flex;
  color: #fff;
}
.th_one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 30%;
  text-align: left;
}
.spealic {
  background: #fff;
  padding: 0 36px;
  display: flex;
  width: 98%;
  margin: 0 auto;
  /* padding-bottom: 30px; */
  height: 60px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
}
.round {
  display: block;
  position: absolute;
  display: block;
    top: 0;
}
.round_normal {
  animation: rotate 6s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
.text {
  text-align: left;
}
.hand {
  cursor: pointer;
}
.hand:hover {
  color: #0085ff;
}
.imgs {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #000;
}
.imgs > img {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imgs > div {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-60%, -50%);
  font-weight: bolder;
  color: #6b6b6b;
}
.add {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.el-end {
  height: 40px;
}
</style>